
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    title: String,
    subtitle: String
  }
});
